import { defineStore } from 'pinia'
import { getProjectList, initProject } from '@/api/modules/project'

export interface Project {
  id: number
  name: string
  description: string
  area: string
  createdAt: string
  createdBy: string
  isShared: number
  createdUser: number
  customerId: number | null
  isCustomized: number
  isDeleted: number
  updatedAt: string
  templateId: number
  isEdit: number
}

export interface ProjectState {
  allProject: Project[]
  currentProjectFetching: boolean
  currentProjectFirstFetching: boolean
  currentProject: Project[]
  current: number
  pages: number
  size: number
  total: number
  name: string
  no_result_name: string
  timeSort: number
  startTime: string
  endTime: string
  exportProjectPopupShow: boolean
  exportProjectId: number
  selectProjectPopupShow: boolean
  isInitialized: boolean
  currentTemplateId: number | null
  currentProjectId: number | null
  mangeProjectPopupShow: boolean
  removeProjectPopupShow: boolean
  removeProjectId: number
}

interface ProjectOptions {
  label: string
  value: number
  templateId: number
  isCustomized: number
}

export const useProjectStore = defineStore('project', {
  state: (): ProjectState => ({
    allProject: [],
    currentProjectFetching: false,
    currentProject: [],
    current: 1,
    pages: 1,
    size: (() => {
      const projectPageSize = localStorage.getItem('projectPageSize')
      if (
        typeof projectPageSize === 'string' &&
        projectPageSize !== null &&
        parseInt(projectPageSize) &&
        [10, 20, 50, 100].includes(parseInt(projectPageSize))
      ) {
        return parseInt(projectPageSize)
      } else {
        return 10
      }
    })(),
    total: 0,
    name: '',
    no_result_name: '',
    timeSort: 2, //1 升序  2 降序
    startTime: '',
    endTime: '',
    exportProjectId: 0,
    exportProjectPopupShow: false,
    currentProjectFirstFetching: false,
    selectProjectPopupShow: false,
    isInitialized: false,
    currentProjectId: localStorage.getItem('currentProjectId')
      ? parseInt(localStorage.getItem('currentProjectId') || '')
      : null,
    currentTemplateId: localStorage.getItem('currentTemplateId')
      ? parseInt(localStorage.getItem('currentTemplateId') || '')
      : null,
    mangeProjectPopupShow: false,
    removeProjectPopupShow: false,
    removeProjectId: 0,
  }),
  getters: {
    allProjectOptions: state => {
      const options: ProjectOptions[] = []
      state.allProject.forEach((item: any) => {
        if (!item.isDeleted) {
          options.push({
            label: item.name,
            value: item.id,
            templateId: item.templateId || 0,
            isCustomized: item.isCustomized,
            templateTypeId: item.tempTypeId,
          })
        }
      })
      return options
    },
    allProjectNames: state => {
      const options: string[] = []
      state.allProject.forEach((item: any) => {
        if (!item.isDeleted) {
          options.push(item.name)
        }
      })
      return options
    },
  },
  actions: {
    getAllProjectList() {
      getProjectList({
        size: 10000,
        current: 1,
      }).then((res: any) => {
        this.allProject = res.data.records || []
      })
    },
    getProjectList() {
      this.currentProjectFetching = true
      getProjectList({
        size: this.size,
        current: this.current,
        name: this.name,
        startTime: this.startTime,
        endTime: this.endTime,
        timeSort: this.timeSort,
      })
        .then((res: any) => {
          this.currentProjectFetching = false
          this.currentProjectFirstFetching = true
          this.currentProject = res.data.records || []
          this.pages = res.data.pages
          this.total = res.data.total
          this.size = res.data.size
          this.current = res.data.current
          this.no_result_name = this.name
        })
        .catch(err => {
          this.currentProjectFetching = false
          this.currentProjectFirstFetching = true
          this.no_result_name = this.name
        })
    },

    resetProjectList() {
      this.currentProject = []
      this.current = 1
      this.pages = 1
      this.size = 10
      this.total = 0
      this.name = ''
      this.startTime = ''
      this.endTime = ''
    },
    showExportProjectPopup(id: number) {
      this.exportProjectId = id
      this.exportProjectPopupShow = true
    },
    hideExportProjectPopup() {
      this.exportProjectPopupShow = false
    },
    showSelectProjectPopup() {
      this.selectProjectPopupShow = true
    },
    hideSelectProjectPopup() {
      this.selectProjectPopupShow = false
    },
    showMangeProjectPopup() {
      this.mangeProjectPopupShow = true
    },
    hideMangeProjectPopup() {
      this.mangeProjectPopupShow = false
    },
    showRemoveProjectPopup() {
      this.removeProjectPopupShow = true
    },
    hideRemoveProjectPopup() {
      this.removeProjectPopupShow = false
    },
    setCurrentProjectId(projectId: number | null) {
      this.currentProjectId = projectId
      if (projectId) {
        localStorage.setItem('currentProjectId', projectId.toString())
      } else {
        localStorage.removeItem('currentProjectId')
      }
    },
    setCurrentTemplateId(templateId: number | null) {
      this.currentTemplateId = templateId
      if (templateId === null) {
        localStorage.removeItem('currentTemplateId')
      } else {
        localStorage.setItem('currentTemplateId', templateId.toString())
      }
    },
  },
})
